<template>
	<div class="my-4">
		<slot></slot>
	</div>
</template>

<script>
export default {};
</script>

<style></style>
